<template>
	<div style="position: relative;" class="phbbg">
		<div style="padding-top: 30px;text-align: right;">
			<img @click="backTo" src="../assets/phb/fanhui.png" style="width: 70px;margin-right: 5%;"/>
		</div>
		<div style="margin-top: 10px;">
			<img  src="../assets/phb/title.png" style="width: 100%;"/>
		</div>
		<!-- margin-top: -80px; -->
		<!-- <div style="margin-top: -80px;margin-left: 12px;">
			<div style="border-radius: 6px;padding: 3px 8px;background-color: #ffe58c;color: #4f2a1a;display: inline-flex;align-items: center;font-weight: bold;font-size: 1.1rem;box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);">
				<div>第一期</div>
				<img src="../assets/phb/sanjiao.png" style="width: 15px;margin-left: 10px;"/>
			</div>
		</div> -->
		<!-- margin-top: 20px; -->
		<div style="margin-top: -80px;">
			<div class="bd_item" @click="goDetail('第一周周榜',1)">第一周周榜</div>
			<div class="bd_item" @click="goDetail('第二周周榜',2)">第二周周榜</div>
			<div class="bd_item" @click="goDetail('第三周周榜',3)">第三周周榜</div>
			<div class="bd_item" @click="goDetail('第四周周榜',4)">第四周周榜</div>
			<div class="bd_item" @click="goDetail('月榜',50)">月榜</div>
		</div>
		<div style="height: 40px;"></div>
	</div>
</template>

<script>
	export default {
		name: 'phb',
		data() {
			return {
				ypid:null
	
			}
		},
		methods: {
			backTo(){
				console.log('backTo')
				this.$router.back()
			},
			goDetail(title,rankid){
				this.$router.push({
					name: 'phbDetail',
					query: {
						ypid: this.ypid,
						title:title,
						rankid: rankid
					}
				}, () => {}, () => {})
			}
		},
		mounted() {
			window.scroll(0,0)
			this.ypid = this.$route.query.ypid
		}
	}
</script>

<style>
	.phbbg{
		background-image: url(../assets/phb/phbbg1.jpg);
		background-size: 100% 100%;
		min-height: 100vh;
	}
	.bd_item{
		width: 75%;
		margin: 0 auto;
		padding: 15px 0;
		text-align: center;
		border-radius: 6px;
		border: 1px solid #ffe58c;
		color: #ffe58c;
		font-size: 1.5rem;
		font-weight: bolder;
		margin-bottom: 20px;
	}
</style>